import { Routes } from '@angular/router';
import { AdminLayoutComponent } from '../core/layouts/admin/layout';
import { TokenGuard } from '../core/guards/token.guard';
import { adminDataResolver } from '../core/resolvers/admin-data.resolver';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    canActivate: [TokenGuard],
    canActivateChild: [TokenGuard],
    resolve: { adminData: adminDataResolver },
    loadChildren: () => import('./Admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: '',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: '',
    loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule),
  },
  { path: '**', redirectTo: 'login', pathMatch: 'full' },
];
